export function generatePdfViewerLink(baseUrl: string, pdfUrl: string, type: string): string {
	const encodedPdfUrl = `${baseUrl}/TermsAndPrivacyViewer?url=${base64url_encode(pdfUrl)}&documentType=${type}`;
	return encodedPdfUrl;
}

function base64url_encode(input: string): string {
	return btoa(input).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
